module.exports = __webpack_public_path__ + "site/img/36.6d429c06.jpg";